import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const accordionItemVariants = cva(
  [
    "", // default style with border
  ],
  {
    variants: {
      variant: {
        default: "border-b",
        noBorder: "", // no border variant
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface AccordionItemProps
  extends React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>,
    VariantProps<typeof accordionItemVariants> {}

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  AccordionItemProps
>(({ className, variant, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn(accordionItemVariants({ variant }), className)}
    {...props}
  />
));

AccordionItem.displayName = "AccordionItem";

export default AccordionItem;
